import { Injectable } from "@angular/core";
import { CanActivate, UrlTree , Router } from "@angular/router";
import { AuthService } from "../core/services/AuthService";
import { k } from "src/environments/properties";




@Injectable({providedIn: 'root'})
export class MustChangePasswordGuard implements CanActivate{

    userToken:string;


    constructor(private authService: AuthService , private router: Router){

    }

    async canActivate(): Promise<boolean | UrlTree> {
        this.userToken = localStorage.getItem(k.token);

        if (this.userToken) {
            let profile = null;

            try {
            profile = await this.authService.dataUser(this.userToken);
            } catch (error) {
            this.authService.forceLocalLogout(true, 'manual');
            return this.router.parseUrl('/login');
            }

            if (profile) {
            // 1. Cambio obligatorio de contraseña
            const mustChangePassword =
                profile?.mustChangePassword ||
                !profile?.passwordChangedAt;

            if (mustChangePassword) {
                return this.router.parseUrl('/force-change-password');
            }

                // 2. Reset/configuración obligatoria de MFA
            const mustResetMfa = profile?.mustChange2fa === true;
            if (mustResetMfa) {
                    if (this.authService.isAuthenticate()) {
                        this.authService.forceLocalLogout(true, 'mfa-reset');
                        return false;
                    }
                    return this.router.parseUrl('/force-reset-mfa');
                }
            }
        }

        return true;
    }
}